import React, { Fragment } from 'react';
import {
    Grid,
    Icon,
    Table
} from "semantic-ui-react";

const BuildRASInfo = React.memo((props) => {
    let _iconpos = document.querySelectorAll('.RASIcon')[0];
    let _curr = window.pageYOffset;
    /* if(Math.abs(_curr-((_iconpos)?_iconpos.offsetTop:0))<=210)
         window.scrollTo(0,_curr-300);*/
    const style = {
        left: (_iconpos) ? (_iconpos.offsetLeft + 255) : 0 + 'px',
        top: (_iconpos) ? (_iconpos.offsetTop - 200) : 0 + 'px'
    }

    let BuildRasDetails = () => {
        if ((localStorage.getItem('RASinfo') != null) && (localStorage.getItem('RASinfo') != "undefined"))
        try {
            return (
                JSON.parse(localStorage.getItem('RASinfo')).map((x, i) => {
                    return (<Table.Row key={i}>
                        <Table.Cell width={2}> {x.branch_name}  </Table.Cell>
                        <Table.Cell width={2}> {x.MonthFrom} - {x.MonthTo}  </Table.Cell>
                        <Table.Cell width={2}> {x.StartTime}  </Table.Cell>
                        <Table.Cell width={2}> {x.No_of_Hrs}  </Table.Cell>
                        <Table.Cell width={2}> {x.Sat_No_of_Hrs}  </Table.Cell>
                        <Table.Cell width={2}> {x.Sun_No_of_Hrs}  </Table.Cell>
                    </Table.Row>
                    )
                })
            )
        }
        catch (error) {
            console.error('Invalid JSON input:', error.message);
        }
        else return "";
    }
    return (
        <div className={`RASInfo_holder ${!props.open ? "hide" : ""}`} style={style}>
            <h3>Firm Calendar Settings <Icon className="xcm-icon-close size-24" onClick={(e) => props.click(e, false)} /></h3>
            <Table singleLine>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Branch Location </Table.HeaderCell>
                        <Table.HeaderCell>Month</Table.HeaderCell>
                        <Table.HeaderCell> Start Time</Table.HeaderCell>
                        <Table.HeaderCell> Week Days Hrs </Table.HeaderCell>
                        <Table.HeaderCell> Saturday Hrs   </Table.HeaderCell>
                        <Table.HeaderCell> Sunday Hrs   </Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
            </Table>
            <div className="RASInfo_content">
                <Table singleLine>
                    <Table.Body>
                        <BuildRasDetails></BuildRasDetails>
                    </Table.Body>
                </Table>
            </div>
        </div>
    );
})

export default BuildRASInfo;